module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hQTCg"))).then(() => parcelRequire('hEqeo'));